// root auth
export const ROUTE_LOGIN = '/login';
export const ROUTE_LOGOUT = '/logout';
export const ROUTE_SIGNUP = '/signup';
export const ROUTE_TOTP = '/totp';
export const ROUTE_FORGOT = '/forgot';
export const ROUTE_FORGOT_SUCCESS = '/forgot-success';
export const ROUTE_NO_ACCESS = '/no-access';
export const ROUTE_MAGIC_LOGIN = '/magic';

export const ROUTE_NO_ROLES = '/noroles';

export const ROUTE_LOADING = '/loading/:type?';

export const ROUTE_HOME = '/';

export const ROUTE_SUPPORT = 'https://hylyght.com/en/faq#using-the-platform';
// Packages
export const ROUTE_PACKAGES = '/packages';
export const ROUTE_PACKAGES_PACKAGE = `/packages/:packageType`;

// Settings
export const ROUTE_SETTINGS = '/settings';
export const ROUTE_SETTINGS_ENTITY = '/settings/:entityId';
export const ROUTE_SETTINGS_SUB = '/settings/:entityId/:setting';
export const ROUTE_SETTINGS_USERS = '/settings/:entityId/users';
export const ROUTE_SETTINGS_USERS_ADD = '/settings/:entityId/users/add';
export const ROUTE_SETTINGS_USERS_USER = '/settings/:entityId/users/:userId';
export const ROUTE_SETTINGS_USERS_USER_EDIT =
  '/settings/:entityId/users/:userId/edit';
export const ROUTE_SETTINGS_USERS_USER_ROLES =
  '/settings/:entityId/users/:userId/roles';

export const ROUTE_SETTINGS_ORGANISATIONS = '/settings/:entityId/organisations';
export const ROUTE_SETTINGS_ORGANISATIONS_ADD =
  '/settings/:entityId/organisations/add';
export const ROUTE_SETTINGS_ORGANISATIONS_ORG =
  '/settings/:entityId/organisations/:organisationId';
export const ROUTE_SETTINGS_ORGANISATIONS_ORG_EDIT =
  '/settings/:entityId/organisations/:organisationId/edit';

export const ROUTE_SETTINGS_BENCHMARKS = '/settings/:entityId/benchmarks';
export const ROUTE_SETTINGS_BENCHMARKS_BENCHMARK =
  '/settings/:entityId/benchmarks/:benchmarkId';
export const ROUTE_SETTINGS_BENCHMARKS_BENCHMARK_TEST =
  '/settings/:entityId/benchmarks/:benchmarkId/test/:benchmarkTestId';
export const ROUTE_SETTINGS_BENCHMARKS_BENCHMARK_TEST_EDIT =
  '/settings/:entityId/benchmarks/:benchmarkId/test/:benchmarkTestId/edit';

export const ROUTE_SETTINGS_TESTSETS = '/settings/:entityId/testsets/:type?';
export const ROUTE_SETTINGS_TESTSETS_TESTSET =
  '/settings/:entityId/testsets/:type/:testSetId';

export const ROUTE_SETTINGS_GLOBAL = '/settings/:entityId/global';
export const ROUTE_SETTINGS_GLOBAL_EDIT = '/settings/:entityId/global/edit';

export const ROUTE_SETTINGS_USAGE = '/settings/:entityId/usage';
export const ROUTE_SETTINGS_EXPORT_DATA = '/settings/:entityId/export';
export const ROUTE_SETTINGS_DEMODATA = '/settings/:entityId/demodata';
export const ROUTE_SETTINGS_SEARCH_USERS = '/settings/:entityId/search-users';

export const ROUTE_SETTINGS_PROFILE = '/settings/:entityId/profile';
export const ROUTE_SETTINGS_PROFILE_EDIT = '/settings/:entityId/profile/edit';
export const ROUTE_SETTINGS_PROFILE_MFA = '/settings/:entityId/mfa';

// Persons
export const ROUTE_PERSONS = '/persons';
export const ROUTE_PERSONS_ENTITY = '/persons/:entityId/:groupId?';
export const ROUTE_PERSONS_ENTITY_POOL = '/persons/:entityId/all';
export const ROUTE_PERSONS_ENTITY_PERSON =
  '/persons/:entityId/:groupId/:personId([a-z0-9-]{36})';
export const ROUTE_PERSONS_ENTITY_PERSON_EDIT =
  '/persons/:entityId/:groupId/:personId([a-z0-9-]{36})/edit';
export const ROUTE_PERSONS_ENTITY_PERSON_SESSIONS_SESSION =
  '/persons/:entityId/:groupId/:personId/sessions/:sessionId([a-z0-9-]{36})';
export const ROUTE_PERSONS_ENTITY_PERSON_SESSIONS_SESSION_REPORT =
  '/persons/:entityId/:groupId/:personId/sessions/:sessionId([a-z0-9-]{36})/report';
export const ROUTE_PERSONS_ENTITY_PERSON_SESSIONS_SESSION_REPORT_TESTDATA =
  '/persons/:entityId/:groupId/:personId/sessions/:sessionId([a-z0-9-]{36})/report/:testDataId([a-z0-9-]{36})';
export const ROUTE_PERSONS_ENTITY_PERSON_SESSIONS_SESSION_TESTS_EDIT =
  '/persons/:entityId/:groupId/:personId/sessions/:sessionId([a-z0-9-]{36})/tests/edit';
export const ROUTE_PERSONS_ENTITY_PERSON_SESSIONS_SESSION_TESTS =
  '/persons/:entityId/:groupId/:personId/sessions/:sessionId([a-z0-9-]{36})/tests';
export const ROUTE_PERSONS_ENTITY_PERSON_SESSIONS_SESSION_TESTS_TESTDATA =
  '/persons/:entityId/:groupId/:personId/sessions/:sessionId([a-z0-9-]{36})/tests/:testDataId([a-z0-9-]{36})';
export const ROUTE_PERSONS_ENTITY_PERSON_SESSIONS_SESSION_TESTS_TESTDATA_EDIT =
  '/persons/:entityId/:groupId/:personId/sessions/:sessionId([a-z0-9-]{36})/tests/:testDataId([a-z0-9-]{36})/edit';
export const ROUTE_PERSONS_ENTITY_PERSON_GLOBAL =
  '/persons/:entityId/:groupId/:personId/global';
export const ROUTE_PERSONS_ENTITY_PERSON_INPUT_DATA =
  '/persons/:entityId/:groupId/:personId/data';
export const ROUTE_PERSONS_ENTITY_PERSON_TESTS =
  '/persons/:entityId/:groupId/:personId/tests';
export const ROUTE_PERSONS_ENTITY_PERSON_GLOBAL_EDIT =
  '/persons/:entityId/:groupId/:personId/global/edit';

// Sessions
export const ROUTE_REPORTS = '/reports';
export const ROUTE_SESSIONS = '/sessions';
export const ROUTE_SESSIONS_ENTITY = '/sessions/:entityId/:sessionsTab?';
export const ROUTE_SESSIONS_ENTITY_SESSION =
  '/sessions/:entityId/:sessionsTab/:sessionId';
export const ROUTE_SESSIONS_ENTITY_SESSION_EDIT =
  '/sessions/:entityId/:sessionsTab/:sessionId([a-z0-9-]{36})/edit';
export const ROUTE_SESSIONS_ENTITY_SESSION_PERSONS =
  '/sessions/:entityId/:sessionsTab/:sessionId([a-z0-9-]{36})/persons';
export const ROUTE_SESSIONS_ENTITY_SESSION_ADD_PERSON =
  '/sessions/:entityId/:sessionsTab/:sessionId([a-z0-9-]{36})/persons/add';
export const ROUTE_SESSIONS_ENTITY_SESSION_PERSON =
  '/sessions/:entityId/:sessionsTab/:sessionId([a-z0-9-]{36})/persons/:personId([a-z0-9-]{36})';
export const ROUTE_SESSIONS_ENTITY_SESSION_PERSON_GLOBAL =
  '/sessions/:entityId/:sessionsTab/:sessionId([a-z0-9-]{36})/persons/:personId([a-z0-9-]{36})/global';
export const ROUTE_SESSIONS_ENTITY_SESSION_PERSON_GLOBAL_EDIT =
  '/sessions/:entityId/:sessionsTab/:sessionId([a-z0-9-]{36})/persons/:personId([a-z0-9-]{36})/global/edit';
export const ROUTE_SESSIONS_ENTITY_SESSION_PERSON_REPORT =
  '/sessions/:entityId/:sessionsTab/:sessionId([a-z0-9-]{36})/persons/:personId([a-z0-9-]{36})/report';
export const ROUTE_SESSIONS_ENTITY_SESSION_PERSON_REPORT_TESTDATA =
  '/sessions/:entityId/:sessionsTab/:sessionId([a-z0-9-]{36})/persons/:personId([a-z0-9-]{36})/report/:testDataId([a-z0-9-]{36})';
export const ROUTE_SESSIONS_ENTITY_SESSION_PERSON_REPORT_EDIT =
  '/sessions/:entityId/:sessionsTab/:sessionId([a-z0-9-]{36})/persons/:personId([a-z0-9-]{36})/report/edit';
export const ROUTE_SESSIONS_ENTITY_SESSION_PERSON_TESTS =
  '/sessions/:entityId/:sessionsTab/:sessionId([a-z0-9-]{36})/persons/:personId([a-z0-9-]{36})/tests';
export const ROUTE_SESSIONS_ENTITY_SESSION_PERSON_TESTS_TESTDATA =
  '/sessions/:entityId/:sessionsTab/:sessionId([a-z0-9-]{36})/persons/:personId([a-z0-9-]{36})/tests/:testDataId([a-z0-9-]{36})';
export const ROUTE_SESSIONS_ENTITY_SESSION_PERSON_TESTS_TESTDATA_EDIT =
  '/sessions/:entityId/:sessionsTab/:sessionId([a-z0-9-]{36})/persons/:personId([a-z0-9-]{36})/tests/:testDataId([a-z0-9-]{36})/edit';
export const ROUTE_SESSIONS_ENTITY_SESSION_PERSON_ADVICE =
  '/sessions/:entityId/:sessionsTab/:sessionId([a-z0-9-]{36})/persons/:personId([a-z0-9-]{36})/advice/:programId';
export const ROUTE_SESSIONS_ENTITY_TEMPLATES = '/sessions/:entityId/templates';
export const ROUTE_SESSIONS_ENTITY_TEMPLATES_TESTSET_EDIT =
  '/sessions/:entityId/:sessionsTab/template/:testSetId/edit';

export const ROUTE_SESSIONS_ENTITY_SESSIONS = '/sessions/:entityId/sessions';
export const ROUTE_SESSIONS_ENTITY_RECURRING = '/sessions/:entityId/recurring';

export const ROUTE_TESTS = '/tests';
export const ROUTE_TESTS_PACKAGE_SESSION =
  '/tests/:packageId/:entityId/:sessionId';
export const ROUTE_SURVEY_PACKAGE_SESSION_PERSON =
  '/tests/:packageId/:entityId/:sessionId([a-z0-9-]{36})/:personId';
export const ROUTE_SURVEY_PACKAGE_SESSION_LIST =
  '/tests/sap/:entityId/:sessionId';

// Results
export const ROUTE_RESULTS = '/results';
export const ROUTE_RESULTS_ENTITY = '/results/:entityId/:popup';
export const ROUTE_RESULTS_ENTITY_POPUP = '/results/:entityId/popup';
export const ROUTE_RESULTS_ENTITY_PERSON =
  '/results/:entityId/:popup/group/:groupId/person/:personId';
export const ROUTE_RESULTS_ENTITY_GROUP =
  '/results/:entityId/:popup/group/:groupId/benchmark/:benchmarkId';

export const ROUTE_RESULTS_ENTITY_SESSION =
  '/results/:entityId/:popup/session/:sessionId';

// Growth
export const ROUTE_GROWTH_PREDICTION = '/growthprediction';

// Growth Tracker
export const ROUTE_GROWTH = '/growthtracker';
export const ROUTE_GROWTH_ENTITY = '/growthtracker/:entityId/:popup';
export const ROUTE_GROWTH_ENTITY_POPUP = '/growthtracker/:entityId/popup';
export const ROUTE_GROWTH_ENTITY_PERSON =
  '/growthtracker/:entityId/:popup/group/:groupId/person/:personId';
export const ROUTE_GROWTH_ENTITY_GROUP =
  '/growthtracker/:entityId/:popup/group/:groupId/benchmark/:benchmarkId';

export const ROUTE_GROWTH_ENTITY_SESSION =
  '/growthtracker/:entityId/:popup/session/:sessionId';

// Exercises
export const ROUTE_EXERCISES = '/exercises';

// Exercises
export const ROUTE_EXERCISES_INDEX = '/exercises/index';
export const ROUTE_EXERCISES_ENTITY = '/exercises/:entityId';
export const ROUTE_EXERCISES_ENTITY_ALL_EXERCISES = '/exercises/:entityId/all';
export const ROUTE_EXERCISES_ENTITY_MY_EXERCISES = '/exercises/:entityId/my';
export const ROUTE_EXERCISES_ENTITY_EXERCISES = '/exercises/:entityId/:tab';
export const ROUTE_EXERCISES_ENTITY_EXERCISE = `/exercises/:entityId/:tab/:exerciseId`;
export const ROUTE_EXERCISES_ENTITY_EXERCISE_EDIT = `/exercises/:entityId/:tab/:exerciseId/edit`;
export const ROUTE_EXERCISES_ENTITY_EXERCISE_LANGUAGE = `/exercises/:entityId/:exerciseId/language/:lang?`;

// Programs
export const ROUTE_EXERCISES_PROGRAMS = '/programs';
export const ROUTE_EXERCISES_PROGRAMS_ENTITY = '/programs/:entityId';
export const ROUTE_EXERCISES_PROGRAMS_ENTITY_PROGRAM =
  '/programs/:entityId/:programId';
export const ROUTE_EXERCISES_PROGRAMS_ENTITY_PROGRAM_PERSONS =
  '/programs/:entityId/:programId/persons';
export const ROUTE_EXERCISES_PROGRAMS_ENTITY_PROGRAM_PERSONS_PERSON_FEEDBACK =
  '/programs/:entityId/:programId/persons/:personId/feedback';
export const ROUTE_EXERCISES_PROGRAMS_ENTITY_PROGRAM_PERSONS_PERSON_GLOBAL =
  '/programs/:entityId/:programId/persons/:personId/global';
export const ROUTE_EXERCISES_PROGRAMS_ENTITY_PROGRAM_PERSONS_PERSON_GLOBAL_EDIT =
  '/programs/:entityId/:programId/persons/:personId/global/edit';
export const ROUTE_EXERCISES_PROGRAMS_ENTITY_PROGRAM_DETAILS =
  '/programs/:entityId/:programId/details';
export const ROUTE_EXERCISES_PROGRAMS_ENTITY_PROGRAM_DETAILS_EDIT =
  '/programs/:entityId/:programId/details/edit';
export const ROUTE_EXERCISES_PROGRAMS_ENTITY_PROGRAM_EDIT =
  '/programs/:entityId/:programId/edit';
export const ROUTE_EXERCISES_PROGRAMS_ENTITY_PROGRAM_EDIT_PERSONS_PERSON =
  '/programs/:entityId/:programId/persons/:personId';
export const ROUTE_EXERCISES_PROGRAMS_ENTITY_PROGRAM_EDIT_PERSONS =
  '/programs/:entityId/:programId/persons';
export const ROUTE_EXERCISES_PROGRAMS_ENTITY_PROGRAM_EDIT_EXERCISES =
  '/programs/:entityId/:programId/exercises';
export const ROUTE_EXERCISES_PROGRAMS_ENTITY_PROGRAM_EXERCISES_EXERCISE =
  '/programs/:entityId/:programId/exercises/:exerciseId';

// Templates
export const ROUTE_EXERCISES_TEMPLATES = '/templates';
export const ROUTE_EXERCISES_TEMPLATES_ENTITY = '/templates/:entityId';
export const ROUTE_EXERCISES_TEMPLATES_ENTITY_TEMPLATE =
  '/templates/:entityId/:templateId';
export const ROUTE_EXERCISES_TEMPLATES_ENTITY_TEMPLATE_DETAILS =
  '/templates/:entityId/:templateId/details';
export const ROUTE_EXERCISES_TEMPLATES_ENTITY_TEMPLATE_DETAILS_EDIT =
  '/templates/:entityId/:templateId/details/edit';
export const ROUTE_EXERCISES_TEMPLATES_ENTITY_TEMPLATE_EXERCISES_EXERCISE =
  '/templates/:entityId/:templateId/exercises/:exerciseId';

// Collections
export const ROUTE_EXERCISES_COLLECTIONS = '/collections';
export const ROUTE_EXERCISES_COLLECTIONS_ENTITY = '/collections/:entityId';
export const ROUTE_EXERCISES_COLLECTIONS_ENTITY_COLLECTIONS =
  '/collections/:entityId/:tab';
export const ROUTE_EXERCISES_COLLECTIONS_ENTITY_MY_COLLECTIONS =
  '/collections/:entityId/my';
export const ROUTE_EXERCISES_COLLECTIONS_ENTITY_OTHER_COLLECTIONS =
  '/collections/:entityId/other';

export const ROUTE_EXERCISES_COLLECTIONS_ENTITY_COLLECTION =
  '/collections/:entityId/:tab/:templateId';
export const ROUTE_EXERCISES_COLLECTIONS_ENTITY_COLLECTION_DETAILS =
  '/collections/:entityId/:tab/:templateId/details';
export const ROUTE_EXERCISES_COLLECTIONS_ENTITY_COLLECTION_DETAILS_EDIT =
  '/collections/:entityId/:tab/:templateId/details/edit';
export const ROUTE_EXERCISES_COLLECTIONS_ENTITY_COLLECTION_EXERCISES =
  '/collections/:entityId/:tab/:templateId/exercises';
export const ROUTE_EXERCISES_COLLECTIONS_ENTITY_COLLECTION_EXERCISES_EXERCISE =
  '/collections/:entityId/:tab/:templateId/exercises/:exerciseId';
export const ROUTE_EXERCISES_COLLECTIONS_ENTITY_COLLECTION_EXERCISES_EXERCISE_EDIT =
  '/collections/:entityId/:tab/:templateId/exercises/:exerciseId/edit';

// Trainings
export const ROUTE_EXERCISES_TRAININGS = '/trainings';
export const ROUTE_EXERCISES_TRAININGS_ENTITY = '/trainings/:entityId';
export const ROUTE_EXERCISES_TRAININGS_ENTITY_TRAINING_DETAILS_EDIT =
  '/trainings/:entityId/:templateId/details/edit';
export const ROUTE_EXERCISES_TRAININGS_ENTITY_TRAINING_DETAILS =
  '/trainings/:entityId/:templateId/details';
export const ROUTE_EXERCISES_TRAININGS_ENTITY_TRAINING =
  '/trainings/:entityId/:templateId';
export const ROUTE_EXERCISES_TRAININGS_ENTITY_TRAINING_EXERCISES_EXERCISE_EDIT =
  '/trainings/:entityId/:templateId/exercises/:exerciseId/edit';
export const ROUTE_EXERCISES_TRAININGS_ENTITY_TRAINING_EXERCISES_EXERCISE_DETAILS =
  '/trainings/:entityId/:templateId/exercises/:exerciseId/details';
export const ROUTE_EXERCISES_TRAININGS_ENTITY_TRAINING_EXERCISES_EXERCISE_DETAILS_EDIT =
  '/trainings/:entityId/:templateId/exercises/:exerciseId/details/edit';
export const ROUTE_EXERCISES_TRAININGS_ENTITY_TRAINING_EXERCISES =
  '/trainings/:entityId/:templateId/exercises';
export const ROUTE_EXERCISES_TRAININGS_ENTITY_TRAINING_EXERCISES_EXERCISE =
  '/trainings/:entityId/:templateId/exercises/:exerciseId';

// Rehab
export const ROUTE_PERSONS_ENTITY_PERSON_MEDICAL =
  '/persons/:entityId/:groupId/:personId/medical/:medicalId?';

// Injury
export const ROUTE_PERSONS_ENTITY_PERSON_MEDICAL_INJURY_DETAIL =
  '/persons/:entityId/:groupId/:personId/medical/:medicalId/injury/:injuryId';
export const ROUTE_PERSONS_ENTITY_PERSON_MEDICAL_INJURY_DETAIL_EDIT =
  '/persons/:entityId/:groupId/:personId/medical/:medicalId/injury/:injuryId/edit';
export const ROUTE_PERSONS_ENTITY_PERSON_MEDICAL_INJURY_REPORTS =
  '/persons/:entityId/:groupId/:personId/medical/:medicalId/injury/:injuryId/reports';
export const ROUTE_PERSONS_ENTITY_PERSON_MEDICAL_INJURY_SCREENINGS =
  '/persons/:entityId/:groupId/:personId/medical/:medicalId/injury/:injuryId/screenings';
export const ROUTE_PERSONS_ENTITY_PERSON_MEDICAL_INJURY_SCREENINGS_ENTITY =
  '/persons/:entityId/:groupId/:personId/medical/:medicalId/injury/:injuryId/screenings/:sessionId';
export const ROUTE_PERSONS_ENTITY_PERSON_MEDICAL_INJURY_SCREENINGS_DETAIL =
  '/persons/:entityId/:groupId/:personId/medical/:medicalId/injury/:injuryId/screenings/:sessionId/global';
export const ROUTE_PERSONS_ENTITY_PERSON_MEDICAL_INJURY_SCREENINGS_DETAIL_EDIT =
  '/persons/:entityId/:groupId/:personId/medical/:medicalId/injury/:injuryId/screenings/:sessionId/global/edit';
export const ROUTE_PERSONS_ENTITY_PERSON_MEDICAL_INJURY_SCREENINGS_RETEST =
  '/persons/:entityId/:groupId/:personId/medical/:medicalId/injury/:injuryId/screenings/:sessionId([a-z0-9-]{36})/retest';
export const ROUTE_PERSONS_ENTITY_PERSON_MEDICAL_INJURY_SCREENINGS_TESTS =
  '/persons/:entityId/:groupId/:personId/medical/:medicalId/injury/:injuryId/screenings/:sessionId([a-z0-9-]{36})/tests';
export const ROUTE_PERSONS_ENTITY_PERSON_MEDICAL_INJURY_SCREENINGS_TESTS_TESTDATA =
  '/persons/:entityId/:groupId/:personId/medical/:medicalId/injury/:injuryId/screenings/:sessionId([a-z0-9-]{36})/tests/:testDataId([a-z0-9-]{36})';
export const ROUTE_PERSONS_ENTITY_PERSON_MEDICAL_INJURY_SCREENINGS_TESTS_TESTDATA_EDIT =
  '/persons/:entityId/:groupId/:personId/medical/:medicalId/injury/:injuryId/screenings/:sessionId([a-z0-9-]{36})/tests/:testDataId([a-z0-9-]{36})/edit';
export const ROUTE_PERSONS_ENTITY_PERSON_MEDICAL_INJURY_SCREENINGS_REPORT_TESTDATA =
  '/persons/:entityId/:groupId/:personId/medical/:medicalId/injury/:injuryId/screenings/:sessionId([a-z0-9-]{36})/report/:testDataId([a-z0-9-]{36})';
export const ROUTE_PERSONS_ENTITY_PERSON_MEDICAL_INJURY_SCREENINGS_REPORT =
  '/persons/:entityId/:groupId/:personId/medical/:medicalId/injury/:injuryId/screenings/:sessionId([a-z0-9-]{36})/report';

// Illness

export const ROUTE_PERSONS_ENTITY_PERSON_MEDICAL_ILLNESS_DETAIL =
  '/persons/:entityId/:groupId/:personId/medical/:medicalId/illness/:illnessId';

export const ROUTE_PERSONS_ENTITY_PERSON_MEDICAL_ILLNESS_DETAIL_EDIT =
  '/persons/:entityId/:groupId/:personId/medical/:medicalId/illness/:illnessId/edit';

// Issues

export const ROUTE_PERSONS_ENTITY_PERSON_MEDICAL_ISSUE_DETAIL =
  '/persons/:entityId/:groupId/:personId/medical/:medicalId/issue/:issueId';
export const ROUTE_PERSONS_ENTITY_PERSON_MEDICAL_ISSUE_DETAIL_EDIT =
  '/persons/:entityId/:groupId/:personId/medical/:medicalId/issue/:issueId/edit';

// Prevention
export const ROUTE_PREVENTION = '/prevention';
export const ROUTE_PREVENTION_ENTITY_ADD_PREVENTION_PERSONS =
  '/prevention/:entityId/add/persons';
export const ROUTE_PREVENTION_ENTITY_EDIT_PREVENTION =
  '/prevention/:entityId/:sessionId([a-z0-9-]{36})/edit';

// User Programs
export const ROUTE_USER_PROGRAMS = '/programs';
export const ROUTE_USER_ENTITY_PROGRAMS = '/programs/:entityId';
export const ROUTE_USER_ENTITY_PROGRAMS_PROGRAM =
  '/programs/:entityId/:programId';
export const ROUTE_USER_ENTITY_PROGRAMS_PROGRAM_FEEDBACK =
  '/programs/:entityId/:programId/feedback';
export const ROUTE_USER_ENTITY_PROGRAMS_PROGRAM_EXERCISE =
  '/programs/:entityId/:programId/exercises/:exerciseId';
export const ROUTE_USER_ENTITY = '/user/:entityId';

// User Sessions
export const ROUTE_USER_SESSIONS_ENTITY = '/sessions/:entityId';
export const ROUTE_USER_SESSIONS_ENTITY_MEDICAL = '/sessions/:entityId/medical';
export const ROUTE_USER_SESSIONS_ENTITY_SESSION =
  '/sessions/:entityId/:sessionId([a-z0-9-]{36})';
export const ROUTE_USER_SESSIONS_ENTITY_SESSION_REPORT =
  '/sessions/:entityId/:sessionId([a-z0-9-]{36})/report';
export const ROUTE_USER_SESSIONS_ENTITY_SESSION_REPORT_TESTDATA =
  '/sessions/:entityId/:sessionId([a-z0-9-]{36})/report/:testDataId([a-z0-9-]{36})';
export const ROUTE_USER_SESSIONS_ENTITY_SESSION_TESTS =
  '/sessions/:entityId/:sessionId([a-z0-9-]{36})/tests';
export const ROUTE_USER_SESSIONS_ENTITY_SESSION_TESTS_TESTDATA =
  '/sessions/:entityId/:sessionId([a-z0-9-]{36})/tests/:testDataId([a-z0-9-]{36})';
export const ROUTE_USER_SESSIONS_ENTITY_SESSION_TESTS_TESTDATA_EDIT =
  '/sessions/:entityId/:sessionId([a-z0-9-]{36})/tests/:testDataId([a-z0-9-]{36})/edit';

// User reports
export const ROUTE_USER_REPORTS = '/reports';
export const ROUTE_USER_REPORTS_ENTITY = '/reports/:entityId';
export const ROUTE_USER_REPORTS_ENTITY_REPORT =
  '/reports/:entityId/:sessionId([a-z0-9-]{36})';
export const ROUTE_USER_REPORTS_ENTITY_REPORT_TESTS =
  '/reports/:entityId/:sessionId([a-z0-9-]{36})/tests';
export const ROUTE_USER_REPORTS_ENTITY_REPORT_REPORT =
  '/reports/:entityId/:sessionId([a-z0-9-]{36})/report';
export const ROUTE_USER_REPORTS_ENTITY_REPORT_REPORT_TESTDATA =
  '/reports/:entityId/:sessionId([a-z0-9-]{36})/report/:testDataId([a-z0-9-]{36})';
export const ROUTE_USER_REPORTS_ENTITY_REPORT_TESTS_TESTDATA =
  '/reports/:entityId/:sessionId([a-z0-9-]{36})/tests/:testDataId([a-z0-9-]{36})';

//User questionnaires
export const ROUTE_USER_QUESTIONNAIRES = '/questionnaires';
export const ROUTE_USER_QUESTIONNAIRES_ENTITY = '/questionnaires/:entityId';
export const ROUTE_USER_QUESTIONNAIRES_ENTITY_QUESTIONNAIRE =
  '/questionnaires/:entityId/:sessionId([a-z0-9-]{36})';
export const ROUTE_USER_QUESTIONNAIRES_ENTITY_QUESTIONNAIRE_TESTS =
  '/questionnaires/:entityId/:sessionId([a-z0-9-]{36})/tests';
export const ROUTE_USER_QUESTIONNAIRES_ENTITY_QUESTIONNAIRE_QUESTIONNAIRE_TESTDATA =
  '/questionnaires/:entityId/:sessionId([a-z0-9-]{36})/questionnaire/:testDataId([a-z0-9-]{36})';
export const ROUTE_USER_QUESTIONNAIRES_ENTITY_QUESTIONNAIRE_TESTS_TESTDATA =
  '/questionnaires/:entityId/:sessionId([a-z0-9-]{36})/tests/:testDataId([a-z0-9-]{36})';
export const ROUTE_USER_QUESTIONNAIRES_ENTITY_QUESTIONNAIRE_TESTS_TESTDATA_EDIT =
  '/questionnaires/:entityId/:sessionId([a-z0-9-]{36})/tests/:testDataId([a-z0-9-]{36})/edit';

// User Exercises
export const ROUTE_PERSONS_ENTITY_PERSON_PROGRAMS =
  '/persons/:entityId/:groupId/:personId/programs';
export const ROUTE_PERSONS_ENTITY_PERSON_PROGRAMS_ENTITY_PROGRAM =
  '/persons/:entityId/:groupId/:personId/programs/:programId';
export const ROUTE_PERSONS_ENTITY_PERSON_PROGRAMS_ENTITY_PROGRAM_EXERCISE =
  '/persons/:entityId/:groupId/:personId/programs/:programId/:exerciseId([a-z0-9-]{36})';
export const ROUTE_PERSONS_ENTITY_PERSON_PROGRAMS_ENTITY_PROGRAM_FEEDBACK =
  '/persons/:entityId/:groupId/:personId/programs/:programId/feedback';

// User Trainings
export const ROUTE_PERSONS_ENTITY_PERSON_TRAININGS =
  '/persons/:entityId/:groupId/:personId/trainings';

// User Groups
export const ROUTE_PERSONS_ENTITY_PERSON_GROUPS =
  '/persons/:entityId/:groupId/:personId/groups';

// User docs
export const ROUTE_PERSONS_ENTITY_PERSON_DOCS =
  '/persons/:entityId/:groupId/:personId/documents';
export const ROUTE_USER_ENTITY_DOCUMENTS = '/documents/:entityId';
export const ROUTE_USER_DOCUMENTS = '/documents';

// Vitale routes
export const ROUTE_LESSONS = '/lessons';
export const ROUTE_LESSONS_ENTITY = '/lessons/:entityId';
export const ROUTE_LESSONS_ENTITY_LESSON = '/lessons/:entityId/:lessonId/';
export const ROUTE_LESSONS_ENTITY_LESSON_EDIT =
  '/lessons/:entityId/:lessonId/edit';

export const ROUTE_LESSONS_ENTITY_LESSON_ANNOTATE =
  '/lessons/:entityId/:lessonId/annotate';
export const ROUTE_LESSONS_ENTITY_LESSON_VIDEOS =
  '/lessons/:entityId/:lessonId/videos';
export const ROUTE_LESSONS_ENTITY_LESSON_VIDEOS_VIDEO =
  '/lessons/:entityId/:lessonId/videos/:videoId';
export const ROUTE_LESSONS_ENTITY_LESSON_VIDEOS_VIDEO_EDIT =
  '/lessons/:entityId/:lessonId/videos/:videoId/edit';
export const ROUTE_LESSONS_ENTITY_LESSON_VIDEOS_VIDEO_ANNOTATE = `/lessons/:entityId/:lessonId/videos/:videoId/annotate`;
export const ROUTE_LESSONS_ENTITY_LESSON_VIDEOS_VIDEO_ANNOTATE_ADD = `/lessons/:entityId/:lessonId/videos/:videoId/annotate/add`;
export const ROUTE_LESSONS_ENTITY_LESSON_VIDEOS_VIDEO_ANNOTATE_EDIT = `/lessons/:entityId/:lessonId/videos/:videoId/annotate/edit/:annotationId`;

export const ROUTE_VIDEOS = '/videos';
export const ROUTE_VIDEOS_INDEX = '/videos/index';
export const ROUTE_VIDEOS_ENTITY = '/videos/:entityId';
export const ROUTE_VIDEOS_ENTITY_VIDEO = `/videos/:entityId/:videoId`;
export const ROUTE_VIDEOS_ENTITY_VIDEO_ADD = `/videos/:entityId/add`;
export const ROUTE_VIDEOS_ENTITY_VIDEO_EDIT = `/videos/:entityId/:videoId/edit`;
export const ROUTE_VIDEOS_ENTITY_VIDEO_ANNOTATE = `/videos/:entityId/:videoId/annotate`;
export const ROUTE_VIDEOS_ENTITY_VIDEO_ANNOTATE_ADD = `/videos/:entityId/:videoId/annotate/add`;
export const ROUTE_VIDEOS_ENTITY_VIDEO_ANNOTATE_EDIT = `/videos/:entityId/:videoId/annotate/edit/:annotationId`;

export const ROUTE_PERSONS_ENTITY_PERSON_VIDEOS =
  '/persons/:entityId/:groupId/:personId/videos';
export const ROUTE_PERSONS_ENTITY_PERSON_VIDEOS_VIDEO =
  '/persons/:entityId/:groupId/:personId/videos/:videoId?';

// Test app
export const ROUTE_TEST = '/test';
export const ROUTE_TEST_ENTITY = '/test/:entityId';
export const ROUTE_TEST_ENTITY_UPLOAD = '/test/:entityId/upload';
export const ROUTE_TEST_ENTITY_EXERCISES = '/test/:entityId/exercises';
export const ROUTE_TEST_ENTITY_EXERCISES_EXERCISE_PYTHON =
  '/test/:entityId/exercises/:exerciseId/:type';
export const ROUTE_TEST_ENTITY_EXERCISES_EXERCISE =
  '/test/:entityId/exercises/:exerciseId/:type?';
export const ROUTE_TEST_ENTITY_ANALYSE = '/test/:entityId/analyse/:type';
export const ROUTE_TEST_ENTITY_ANALYSE_PYTHON = '/test/:entityId/analyse/:type';

export const ROUTE_MOBILE_AUTHENTICATE = '/mobileAuth';
